import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppConfigService } from 'src/app/_service/appconfigservice';
import { EventLogs } from 'src/app/models/eventLog.model';

@Injectable({
  providedIn: 'root'
})
export class EventlogsService {

  gnBaseURL: any;

  //get plantId from breadcrumbs
  private plantIdSource = new BehaviorSubject<number | null>(null);
  plantId$ = this.plantIdSource.asObservable();

  setPlantId(plantId: number) {
    this.plantIdSource.next(plantId);
  }
  //get trainid from breadcrumbs
  private trainIdSource = new BehaviorSubject<number | null>(null);
  trainId$ = this.trainIdSource.asObservable();

  setTrainId(trainId: number) {
    this.trainIdSource.next(trainId);
  }

  constructor(private http: HttpClient,private appURL: AppConfigService) {
    this.gnBaseURL=this.appURL.getServerUrl(); 
  }

  getEventLogsById(id: string): Observable<EventLogs> {
    return this.http.get<EventLogs>(this.gnBaseURL + 'EventLog/GetEventlogById/' + id);
  }

  getAllEventLogss(): Observable<EventLogs[]> {
    return this.http.get<EventLogs[]>(this.gnBaseURL + 'EventLog/GetEventLogList');
  }

  getEventLogsListByTrainId(id:string) {
    return this.http.get<EventLogs[]>(this.gnBaseURL+ 'EventLog/GetEventLogsListByTrainId/' + id);
  }

  addEventLogs(
    addEventLogsRequest:EventLogs
  ): Observable<EventLogs> {
    console.log(addEventLogsRequest);
    return this.http.post<EventLogs>(
      this.gnBaseURL + 'EventLog/AddEventLogDetails',
      addEventLogsRequest
    );
  }

  updateEventLogs(id: number, model: EventLogs): Observable<EventLogs> {
    return this.http.post<EventLogs>(
      this.gnBaseURL + 'EventLog/EditEventLog/' + id,
      model
    )
  }

  deleteEventLogs(Id: number){
    return this.http.get(
      this.gnBaseURL + 'EventLog/'+ Id +'/action/delete' 
    );
  }
}
